import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { SettingsIcon, LogOutIcon, UserIcon } from 'lucide-react';
interface UserMenuProps {
  isOpen: boolean;
  onClose: () => void;
}
const UserMenu: React.FC<UserMenuProps> = ({
  isOpen,
  onClose
}) => {
  const navigate = useNavigate();
  const handleSettings = () => {
    navigate('/account');
    onClose();
  };
  const handleLogout = () => {
    // Aquí iría la lógica de cerrar sesión
    console.log('Cerrando sesión...');
    onClose();
  };
  return <AnimatePresence data-id="element-244">
      {isOpen && <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -10
    }} transition={{
      duration: 0.2
    }} className="absolute top-full right-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden z-50" data-id="element-245">
          {/* User Info Header */}
          <div className="px-4 py-3 border-b border-gray-100 bg-gray-50" data-id="element-246">
            <div className="flex items-center space-x-3" data-id="element-247">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-248">
                <span className="text-blue-600 font-medium" data-id="element-249">RS</span>
              </div>
              <div className="flex-1 min-w-0" data-id="element-250">
                <p className="text-sm font-medium text-gray-900 truncate" data-id="element-251">
                  Roberto Sánchez
                </p>
                <p className="text-xs text-gray-500 truncate" data-id="element-252">Super Admin</p>
              </div>
            </div>
          </div>
          {/* Menu Items */}
          <div className="py-2" data-id="element-253">
            <button onClick={handleSettings} className="w-full flex items-center space-x-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-254">
              <SettingsIcon size={18} className="text-gray-500" data-id="element-255" />
              <span data-id="element-256">Configuración de cuenta</span>
            </button>
            <div className="border-t border-gray-100 my-1" data-id="element-257"></div>
            <button onClick={handleLogout} className="w-full flex items-center space-x-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors" data-id="element-258">
              <LogOutIcon size={18} data-id="element-259" />
              <span data-id="element-260">Cerrar sesión</span>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
export default UserMenu;